<!-- <header [preLogin]="false"></header> -->
<div class="post-login-1">
    <!-- <div class="post-login-1-col-1 h-100">
        <app-left-panel-prelogin activeTab="2"></app-left-panel-prelogin>
    </div> -->
    <div class="post-login-1-col-2 h-100 p-mobile-15">


       
              


        <grid-row class="justify-content-center pt-160 pt-mobile-0 h-100vh-101">
            <grid-col col="8" mobile="12">
               
                <div class="font-size-24px font-400 color-base-700 line-h-32 letter-spacing-1">
                    {{ "Chooseyour" | translate }}
                </div>
                <div class="mt-30 custom-radio-box">


                    <grid-row class="col-space">
                        <grid-col col="6" mobile="12">
                          
                            <div class="custom-radio-box-item" [ngClass]="activeTab == 1 ? 'active' : ''" (click)="changeTab(1)">
                                <grid-row class="col-space-min align-item-center">
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-sahel v-align-middle text-align-left" width="45" height="45"></ng-icon>
                                    </grid-col>
                                    <grid-col col="9" mobile="auto">
                                        <div class="font-size-14px font-600 color-base-1500 line-h-22">
                                            {{ "BahrainCredit" | translate }}
                                        </div>
                                        <div class="font-size-12px font-400 color-base-500 line-h-18">
                                            {{ "Accessyourstandard" | translate }}
                                        </div>
                                    </grid-col>
                                </grid-row>
                                <div class="bg-color-base-900 p-16 br-12 mt-20 link">
                                    <grid-row class="col-space-min align-item-center">
                                        <grid-col col="auto">
                                        <ng-icon iconClass="icon-in-active-check v-align-middle text-align-left"  width="15" height="15"></ng-icon>
                                        </grid-col>
                                        <grid-col col="9" mobile="auto">
                                            <div class="font-size-12px font-400 color-base-500 line-h-18">
                                                {{ "Flexiblerepaymentoptions" | translate }}
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                    <grid-row class="col-space-min align-item-center mt-10">
                                        <grid-col col="auto">
                                        <ng-icon iconClass="icon-in-active-check v-align-middle text-align-left" width="15"
                                            height="15"></ng-icon>
                                        </grid-col>
                                        <grid-col col="9" mobile="auto">
                                            <div class="font-size-12px font-400 color-base-500 line-h-18">
                                                {{ "Competitiveinterestrate" | translate }}
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                    <grid-row class="col-space-min align-item-center mt-10">
                                        <grid-col col="auto">
                                        <ng-icon iconClass="icon-in-active-check v-align-middle text-align-left"  width="15"
                                            height="15"></ng-icon>
                                        </grid-col>
                                        <grid-col col="9" mobile="auto">
                                            <div class="font-size-12px font-400 color-base-500 line-h-18">
                                                {{ "Quickapprovalprocess" | translate }}
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                </div>
                            </div>
                        </grid-col>
                        <grid-col col="6" mobile="12" class="mt-mobile-15">
                            <div class="custom-radio-box-item" [ngClass]="activeTab == 2 ? 'active' : ''" (click)="changeTab(2)">
                                <grid-row class="col-space-min align-item-center">
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-islamic v-align-middle text-align-left" width="44" height="44"></ng-icon>
                                    </grid-col>
                                    <grid-col col="9" mobile="auto">
                                        <div class="font-size-14px font-600 color-base-1500 line-h-22">
                                            {{ "TasheelatIslamic" | translate }}
                                        </div>
                                        <div class="font-size-12px font-400 color-base-500 line-h-18">
                                            {{ "ExploreShariahcompliant" | translate }}
                                        </div>
                                    </grid-col>
                                    
                                </grid-row>
                                <div class="bg-color-base-900 p-16 br-12 mt-20 link"
                                    (click)="changeTab(2)">
                                    <grid-row class="col-space-min align-item-center">
                                        <grid-col col="auto">
                                            <ng-icon iconClass="icon-in-active-check v-align-middle text-align-left"width="15"
                                                height="15"></ng-icon>
                                        </grid-col>
                                        <grid-col col="9" mobile="auto">
                                            <div class="font-size-12px font-400 color-base-500 line-h-18">
                                                {{ "Flexiblerepaymentoptions" | translate }}
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                    <grid-row class="col-space-min align-item-center mt-10">
                                        <grid-col col="auto">
                                            <ng-icon iconClass="icon-in-active-check v-align-middle text-align-left" width="15"
                                                height="15"></ng-icon>
                                        </grid-col>
                                        <grid-col col="9" mobile="auto">
                                            <div class="font-size-12px font-400 color-base-500 line-h-18">
                                                {{ "Competitiveinterestrate" | translate }}
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                    <grid-row class="col-space-min align-item-center mt-10">
                                        <grid-col col="auto">
                                        <ng-icon iconClass="icon-in-active-check v-align-middle text-align-left" width="15"
                                            height="15"></ng-icon>
                                        </grid-col>
                                        <grid-col col="9" mobile="auto">
                                            <div class="font-size-12px font-400 color-base-500 line-h-18">
                                                {{ "Quickapprovalprocess" | translate }}
                                            </div>
                                        </grid-col>
                                    </grid-row>
                                  
                                </div>
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-center mt-50">
                        <grid-col col="6" mobile="12">
                            <button class="btn-dft" [disabled]="isValid()" (click)="next()">
                                {{ "NEXT" | translate }}
                            </button>

                           
                        </grid-col>
                    </grid-row>
                </div>
            </grid-col>

        </grid-row>
    </div>
</div>